/**
 * Helpers for AI Council pipeline session sync / accordion state.
 *
 * Background: a 30s poll used to treat "DB still has the step we already show"
 * as "step just finished", which re-ran loadSessionById and slammed expanded
 * result panels shut. These helpers encode the intended rules in one place.
 */

export type PipelineProgressSnapshot = {
  memberResults: unknown;
  presidentEvaluation: unknown;
  personaResults: unknown;
  finalSynthesis: unknown;
};

/** True when the server has pipeline progress not yet reflected in local state. */
export function hasNewPipelineProgress(
  local: PipelineProgressSnapshot,
  server: {
    hasMemberResults: boolean;
    hasPresidentEval: boolean;
    hasPersonaResults: boolean;
    hasFinalSynthesis: boolean;
    dbStep: number;
  },
  currentStep: number,
): boolean {
  return (
    (!local.memberResults && server.hasMemberResults) ||
    (!local.presidentEvaluation && server.hasPresidentEval) ||
    (!local.personaResults && server.hasPersonaResults) ||
    (!local.finalSynthesis && server.hasFinalSynthesis) ||
    server.dbStep > currentStep
  );
}

/**
 * Same-session silent reloads (poll / Sync from server) must keep the user's
 * expanded/collapsed accordion choices. Only first open or switching sessions
 * should reset collapse to "completed steps collapsed".
 */
export function shouldResetCollapsedStepsOnLoad(
  sessionId: number,
  pipelineSessionId: number | null,
  activeSessionId: number | null,
): boolean {
  return pipelineSessionId !== sessionId && activeSessionId !== sessionId;
}
